export default "__VITE_ASSET__CGjdKVVc__"